import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Nav from '../components/Nav.js';
import Masthead from '../components/Housing/Masthead.js';
import SubMasthead from '../components/Housing/SubMasthead';
import SecondaryNav from '../components/SecondaryNav';
import ModalOverlay from '../components/ModalOverlay';
import Solutions from '../components/Housing/Solutions';
import HousingMap from '../components/Housing/map';
import Committed from '../components/Housing/Committed';
import { GAfirePageView } from '../components/Tracking';
import Footer from '../components/Footer';
import ProgramsResources from "../components/Housing/ProgramsResources";
import Disclaimers from '../components/Disclaimers.js';
import { useKonami } from 'react-konami-code';

import { fireTag } from '../libs/analytics.js';

import 'wicg-inert';
import Featured from "../components/Housing/Featured";
import { isEs } from "../libs/lang";

const Housing = ({
					 uiState,
					 activePage,
					 isMobile,
					 handleEvent,
					 resetMap,
					 chooseDropdownType,
					 mapLoading,
					 alreadyShown,
					 location,
					 results,
					 checkForCityOrZip,
					 goToAnchor,
					 closeExitOverlay,
					 addExitClickListeners,
					 displayModalOverlay,
					 modalOverlay,
				 }) => {


	const [shouldBeInert, setShouldBeInert] = useState(false);
	const [gridVisible, setGridVisible] = useState(false);
	addExitClickListeners();

	const toggleGrid = () => {
		const grid = document.getElementsByClassName('grid')[0];
		grid.style.display = (!gridVisible) ? 'none' : 'block';
		setGridVisible(!gridVisible)
	}
	const KonamiElement = () => {
		useKonami(toggleGrid, {
			code: [37, 39, 37, 39]
		});
		return <div className="grid" style={{display: gridVisible ? 'block' : 'none'}}/>;
	};

	const toggleInert = () => {
		setShouldBeInert(!shouldBeInert)
	}

	document.addEventListener('keydown', (e) => {
		if (e.keyCode === 9) {
			// console.log(document.activeElement)
		}
	});

  const title = isEs() ? "Abordamos el acceso a la vivienda a precio asequible desde todos los ángulos | Wells Fargo" : "Tackling housing affordability from every angle | Wells Fargo";
	const description = isEs() ? "Obtén más información sobre cómo estamos brindando opciones flexibles de financiamiento a los compradores de vivienda, proporcionando financiamiento a las constructoras para que construyan más viviendas y ofreciendo más innovaciones en la vivienda para el futuro." : "Learn more about how we’re working to preserve, build, and develop innovative solutions for housing affordability.";
	const image = "https://welcome.wf.com/impact/images/housing-affordability-share.jpg";

	return (
		<>
			<Helmet>
				<html lang={isEs() ? 'es' : 'en'} />
				<title>{`${title}`}</title>
				<link rel="canonical" href="https://welcome.wf.com/impact/"/>
				<meta name="robots" content={location.search.indexOf('target=district') > -1 ? 'noindex, nofollow' : 'index, follow'}/>
				<meta name="description" content={`${description}`}/>
				<meta property="image" content={`${image}`}/>

				<meta property="og:title" content={title}/>
				<meta property="og:url" content="https://www.wellsfargo.com/impact/"/>
				<meta property="og:description" content={description}/>
				<meta property="og:image" content={`${image}`}/>

				<meta property="twitter:title" content={title}/>
				<meta property="twitter:url" content="https://www.wellsfargo.com/impact/"/>
				<meta property="twitter:description" content={description}/>
				<meta property="twitter:image" content={image}/>
				{/* Adobe DMP Tag */}
				<script src="https://welcome.wf.com/common/js/ext/visitorapi_3.4.min.js"/>
			</Helmet>
			<Nav
				handleEvent={handleEvent}
				isNotHomePage={false}
				activePage={activePage}
				isMobile={isMobile}
				showExternalNav
				toggleInert={toggleInert}
				shouldBeInert={shouldBeInert}
			/>
			{!isMobile && (
				<SecondaryNav page="Housing" shouldBeInert={shouldBeInert} activePage="housing" isEs={isEs}/>
			)}
			<main ref={node => node && (shouldBeInert ? node.setAttribute('inert', '') : (node.removeAttribute('inert')))}>
				<Masthead
					styles="housing"
					goToAnchor={goToAnchor}
					displayModalOverlay={displayModalOverlay}
					isMobile={isMobile}
					shouldBeInert={shouldBeInert}
				/>
				<SubMasthead/>
				<Solutions/>
				<Featured/>
				<ProgramsResources/>
				<HousingMap
					uiState={uiState}
					handleEvent={handleEvent}
					resetMap={resetMap}
					chooseDropdownType={chooseDropdownType}
					mapLoading={mapLoading}
					alreadyShown={alreadyShown}
					location={location}
					results={results}
					checkForCityOrZip={checkForCityOrZip}
				/>
				<Committed/>
				<Disclaimers goToAnchor={goToAnchor} route="housing" shouldBeInert={shouldBeInert}/>
				{/*<KonamiElement className="grid"/>*/}
			</main>


			<Footer id="footer" footerStyles="global" shouldBeInert={shouldBeInert} activePage={activePage}/>

			<div className="nav-overlay mobile-only" style={{display: 'none'}}/>
			{modalOverlay && modalOverlay.open && (
				<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay}/>
			)}


			{/* Adobe retargeting tag */}
			{
				/*
					REMOVE TAG

						<img alt="" src="https://rtd-tm.everesttech.net/upi/?sid=s6cvr4h2qH04B3WUwCOG&cs=1" style={{display: 'none'}}/>

				*/
			}
		</>
	);
};

export default withRouter(Housing);
